// extracted by mini-css-extract-plugin
export default {"hideTooltip":"L9-z","fadeIn":"M9-z","delay":"N9-z","recommendedSizeTooltip":"O9-z"};